/**
 * Firebase 分析相关的常量
 */

// 货币消耗相关 货币的名称 
export const VIRTUAL_NAME_ENERGY = 'Energy'
export const VIRTUAL_NAME_CRYSTAL = 'Crystals'
// 消耗获取的类型
export const VIRTUAL_SPEND_ITEM_CHAT = 'Chat'


// 注册/登录方式
export const LOGIN_METHOD_EMAIL = 'Email' as const
export const LOGIN_METHOD_GOOGLE = 'Google' as const
export const LOGIN_METHOD_APPLE = 'Apple' as const


// SelectContent相关
export const ROBOT_CHAT = 'RobotChat' // 机器人聊天
export const MEMORY_DETAIL = 'MemoryDetail' // 机器人聊天


// share相关
export const ROBOT_SHARE = 'RobotShare'
export const INVITATION_CODE_SHARE = 'InvitationCode'
export const MEMORY_SHARE = 'MemoryShare'
export const SHARE_METHOD_MANUAL = 'Manual' // 手动分享
export const SHARE_METHOD_BROWSER = 'Browser' // 浏览器分享
